'use client';

import type { WbSession } from '@weberus/session';
import { useEffect } from 'react';
import { KinesisTracker } from '@weberus/client-tracker';

interface KinesisTrackerInitializerProps {
  hashedMemberNo?: WbSession['hashedMemberNo'];
  memberClass?: WbSession['memberClass'];
  nolMemberProxyId?: WbSession['nolMemberProxyId'];
}

const KinesisTrackerInitializer = ({
  hashedMemberNo,
  memberClass,
  nolMemberProxyId,
}: KinesisTrackerInitializerProps) => {
  useEffect(() => {
    // local 로깅 제외
    // if (process.env.NEXT_PUBLIC_SERVICE_ENV === 'local') return;

    KinesisTracker.initialize({
      IdentityPoolId: process.env.NEXT_PUBLIC_CREDENTIAL_POOL_ID,
      streamName: process.env.NEXT_PUBLIC_KINESIS_STREAM_NAME,
      isLoginUser: Boolean(hashedMemberNo),
      memberGrade: memberClass ?? undefined,
      hashedMemberNo: hashedMemberNo ?? undefined,
      nolMemberProxyId: nolMemberProxyId ?? undefined,
      collectImpressionBatches: false,
    });
  }, [hashedMemberNo, memberClass, nolMemberProxyId]);

  return null;
};

export default KinesisTrackerInitializer;
